import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import moment from 'moment';
import { Button } from '@ontruck/orc';

import ContractList from 'components/ContractList';

import style from './style.module.scss';

class Contracts extends Component {
  static propTypes = {
    intl: PropTypes.object,
    contracts: PropTypes.array,
    onNewContract: PropTypes.func,
    onEditContract: PropTypes.func,
    allowNew: PropTypes.bool,
  };

  static defaultProps = {
    allowNew: true,
  };

  constructor(props) {
    super(props);
    this.handleEdit = this.handleEdit.bind(this);
  }

  handleEdit(id) {
    const { onEditContract } = this.props;
    onEditContract(id);
  }

  render() {
    const { intl, contracts, onNewContract, allowNew } = this.props;

    const t = intl.messages.components.CarrierDetails;
    const today = moment();
    const currentContracts = contracts.filter(
      (contract) =>
        moment(contract.start_date).isSameOrBefore(today, 'day') &&
        (!contract.end_date || moment(contract.end_date).isSameOrAfter(today, 'day'))
    );
    const futureContracts = contracts.filter((contract) =>
      moment(contract.start_date).isAfter(today, 'day')
    );
    const pastContracts = contracts.filter((contract) =>
      moment(contract.end_date).isBefore(today, 'day')
    );

    return (
      <div className={style.section}>
        <h2 className={style.sectionTitle}>{t.contracts_title}</h2>
        <Button
          ghost
          skin="primary"
          fullWidth
          className={style.addDriverButton}
          onClick={onNewContract}
          disabled={!allowNew}
          text={t.contracts_create}
        />

        {contracts.length ? (
          <div>
            {currentContracts.length ? (
              <div>
                <h3>
                  {t.contracts_current} ({currentContracts.length})
                </h3>
                <ContractList contracts={currentContracts} onRowClick={this.handleEdit} />
              </div>
            ) : null}
            {futureContracts.length ? (
              <div>
                <h3>
                  {t.contracts_future} ({futureContracts.length})
                </h3>
                <ContractList contracts={futureContracts} onRowClick={this.handleEdit} />
              </div>
            ) : null}
            {pastContracts.length ? (
              <div>
                <h3>
                  {t.contracts_past} ({pastContracts.length})
                </h3>
                <ContractList contracts={pastContracts} onRowClick={this.handleEdit} />
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    );
  }
}

export default injectIntl(Contracts);
